import { render, staticRenderFns } from "./PagoSuccess.vue?vue&type=template&id=2cf18046&"
import script from "./PagoSuccess.vue?vue&type=script&lang=js&"
export * from "./PagoSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PagoSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports